// extracted by mini-css-extract-plugin
export default {"related-news":"RelatedNews_related-news__4Lv0J","related-tags-tabs-container":"RelatedNews_related-tags-tabs-container__IRTOQ","no-data":"RelatedNews_no-data__rbQpa"};